/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum GlycemicRescheduleAliases {
  AUTOCOMPLETE_REASON = 'autocomplete-reason',
  BUTTON_SCHEDULE = 'button-schedule',
  CHECKBOX_RESCHEDULE = 'checkbox-reschedule',
  CONTAINER_PANEL_BUTTON_CONFIRMATION = 'container-panel-button-confirmation',
  FETCH_REASON = 'fetch-reason',
  FIELD_DESIRED_TIME = 'field-desired-time',
  FIELD_JUSTIFICATION = 'field-justification',
  FIELD_REASON = 'field-reason',
  FIELD_RESCHEDULE_PREVIOUS = 'field-reschedule-previous',
  FORM_SCHEDULE = 'form-schedule',
  GLYCEMIC_INFO_HEADER = 'glycemic-info-header',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_DESIRED_TIME = 'input-desired-time',
  LAYOUT_RESCHEDULE = 'layout-reschedule',
  MAPPER_REASON = 'mapper-reason',
  PANEL_BUTTON_CONFIRMATION = 'panel-button-confirmation',
  RESCHEDULE_CONTEXTUAL_BAR = 'reschedule-contextual-bar',
  RESCHEDULE_PANEL = 'reschedule-panel',
  TEXT_AREA_JUSTIFICATION = 'text-area-justification',
  TEXT_REASON = 'text-reason',
}
export { GlycemicRescheduleAliases };
